export const ROUTES = {
  INTRODUCTION: "/",

  PV_SETUP: "/pv-setup",
  WALLBOX: "/wallbox-setup",
  BATTERY_SETUP: "/battery-setup",
  ANNUAL_GRID_SUPPLY: "/annual-grid-supply",
  SMART_METER: "/smart-meter",
  CALCULATED_SAVINGS: "/calculated-savings",
  TARIF: "/tarif-selection",

  YOUR_NAME: "/your-name",
  CONTACT_INFORMATION: "/contact-information",
  ADDRESS: "/address",
  TECHNICAL_DETAILS: "/technical-details",

  CONTRACT_CHANGE: "/contract-change",
  CURRENT_SUPPLIER: "/current-supplier",
  DATE_OF_CONTRACT_START: "/date-of-contract-start",

  PAYMENT_DETAILS: "/payment-details",
  FEED_IN_OFFER: "/feed-in-offer",
  CONTRACT_SUMMARY: "/contract-summary",

  CONCLUSION: "/conclusion",
  ERROR: "/error",
};

export const DEMO_ROUTES = {
  DEMO: "/b2cdemo/websocket",
};

export const ONBOARDING_ROUTES = {
  ONBOARDING_SYSTEM: "/onboarding/system",
  ONBOARDING_CONNECTED_DEVICES: "/onboarding/connected-devices",
  ONBOARDING_ERROR_RETRY: "/onboarding/error-retry",
};

export const SITE_AUTHENTICATION_ROUTES = {
  START: "/site-authentication/start/",
  SUCCESS: "/site-authentication/success",
  FAILED: "/site-authentication/failed",
  AUTHENTICATION_CALLBACK: "/site-authentication/authentication-callback",
};

export const SELF_ONBOARDING_ROUTES = {
  COMPATIBILITY: "/selfonboarding/compatibility/check/",
  ACCESS: "/selfonboarding/compatibility/access",
  ACCESS_SUCCESS: "/selfonboarding/compatibility/access-success",
  ACCESS_FAILED: "/selfonboarding/compatibility/access-failed",
  AUTHENTICATION_CALLBACK:
    "/selfonboarding/compatibility/authentication-callback",
};
